// extracted by mini-css-extract-plugin
module.exports = {"root":"InquiryEmailGate_root__3i9mO"};